import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/ui/core";

export interface PackageDiscountBadgeProps {
  /** `discountPercent` del paquete. Del servidor: es EL dato del contrato. */
  percent: number;
}

/**
 * El porcentaje de descuento del paquete.
 *
 * ── Por qué esto SÍ es un badge ──────────────────────────────────────
 * Las píldoras de RÓTULO están fuera del sistema: un "PAQUETES" con
 * cápsula encima de un título no aporta nada y compite con los badges de
 * verdad. Este comunica un ESTADO de lo que se está mirando —está
 * rebajado, y cuánto—, que es exactamente para lo que el badge se
 * conserva.
 *
 * ── El número no se deriva ───────────────────────────────────────────
 * Es `pkg.discountPercent` tal cual. El contrato dice que el descuento es
 * el dato y el precio sale de él, no al revés; recalcularlo aquí a partir
 * de lista y precio daría un 14.98% por el redondeo al centavo y la
 * tarjeta contradiría al panel de administración.
 *
 * `variant="success"` es `ds-ok-t` (#6B5B95) sobre `ds-ok-bg` (#E8E3EF):
 * 4.7:1, que pasa el mínimo para texto pequeño.
 */
export function PackageDiscountBadge({ percent }: PackageDiscountBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge variant="success" size="sm">
      {t("{{n}}% menos", { n: percent })}
    </Badge>
  );
}
